/** Ordered pairs so select UI and derived maps stay in workflow order. */
const FUNDING_OUTREACH_STATUS_ENTRIES: readonly [string, string][] = [
  ["to_contact", "To contact"],
  ["pending_send", "Sending"],
  ["contacted", "Contacted"],
  ["replied", "Replied"],
  ["approved", "Approved"],
  ["declined", "Declined"],
  ["report_due", "Report due"],
  ["completed", "Completed"],
];

/** Labels for `funding_outreach.status` (and filter/sort by value). */
export const FUNDING_OUTREACH_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  FUNDING_OUTREACH_STATUS_ENTRIES,
);

/** Options for status `<select>` fields, in workflow order. */
export const FUNDING_OUTREACH_STATUS_SELECT_OPTIONS = FUNDING_OUTREACH_STATUS_ENTRIES.map(
  ([value, label]) => ({
    value,
    label,
  }),
);

export function fundingOutreachStatusLabel(status: string | null | undefined): string {
  if (status == null || status === "") return "—";
  return FUNDING_OUTREACH_STATUS_LABELS[status] ?? status;
}

const FUNDING_APPEAL_STATUS_ENTRIES: readonly [string, string][] = [
  ["open", "Open"],
  ["closed", "Closed"],
  ["archived", "Archived"],
];

/** Labels for `funding_appeal.status`. */
export const FUNDING_APPEAL_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  FUNDING_APPEAL_STATUS_ENTRIES,
);

/** Options for appeal status `<select>` fields. */
export const FUNDING_APPEAL_STATUS_SELECT_OPTIONS = FUNDING_APPEAL_STATUS_ENTRIES.map(([value, label]) => ({
  value,
  label,
}));

/** Sorted `[value, label]` pairs for status filter `<select>`s. */
export function fundingLabelFilterOptionEntries(labels: Record<string, string>): readonly [string, string][] {
  return Object.entries(labels).sort((a, b) => a[1].localeCompare(b[1]));
}

export const FUNDING_OUTREACH_STATUS_FILTER_OPTIONS = fundingLabelFilterOptionEntries(
  FUNDING_OUTREACH_STATUS_LABELS,
);

export const FUNDING_APPEAL_STATUS_FILTER_OPTIONS = fundingLabelFilterOptionEntries(
  FUNDING_APPEAL_STATUS_LABELS,
);

/** Pill `color` for `funding_outreach.status` (matches `@mixitone/components` Pill). */
export type FundingOutreachStatusPillColor =
  | "outlineGreen"
  | "outlineRed"
  | "yellow"
  | "purple"
  | "outlineBlue";

export function fundingOutreachStatusPillColor(status: string): FundingOutreachStatusPillColor {
  if (status === "approved") return "outlineGreen";
  if (status === "declined") return "outlineRed";
  if (status === "pending_send") return "yellow";
  if (status === "replied") return "purple";
  return "outlineBlue";
}

export function fundingAppealStatusLabel(status: string | null | undefined): string {
  if (status == null || status === "") return "—";
  return FUNDING_APPEAL_STATUS_LABELS[status] ?? status;
}

const FUNDER_TYPE_ENTRIES: readonly [string, string][] = [
  ["council", "Council"],
  ["trust", "Trust"],
  ["business", "Business"],
  ["individual", "Individual"],
  ["organisation", "Organisation"],
];

/** Labels for `funder.funder_type`. */
export const FUNDER_TYPE_LABELS: Record<string, string> = Object.fromEntries(FUNDER_TYPE_ENTRIES);

/** Options for funder type `<select>` fields. */
export const FUNDER_TYPE_SELECT_OPTIONS = FUNDER_TYPE_ENTRIES.map(([value, label]) => ({
  value,
  label,
}));

export function funderTypeLabel(type: string | null | undefined): string {
  if (type == null || type === "") return "—";
  return FUNDER_TYPE_LABELS[type] ?? type;
}
